import React from 'react';
import {
  Bar,
  CheckPointContainer,
  CheckPointSubTitle,
  CheckPointTitle,
  Container,
  ContentContainer,
  Point,
  TextSection,
  TimelineContainer,
} from './Timeline.styles';
import { CheckPointProps, TimelineProps, TimelineSubComponentsProps } from './Timeline.types';

const CheckPoint: React.FC<CheckPointProps> = ({
  title,
  subTitle,
  isActive = false,
  noBar,
  children,
  ...props
}) => {
  return (
    <CheckPointContainer {...props}>
      <TimelineContainer>
        <Point active={isActive} />
        <Bar shouldDisplay={!noBar} />
      </TimelineContainer>
      <TextSection>
        <CheckPointTitle active={isActive}>{title}</CheckPointTitle>
        <CheckPointSubTitle>{subTitle}</CheckPointSubTitle>
        <ContentContainer>{children}</ContentContainer>
      </TextSection>
    </CheckPointContainer>
  );
};

CheckPoint.displayName = 'CheckPoint';

const Timeline: React.FC<TimelineProps> & TimelineSubComponentsProps = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

Timeline.CheckPoint = CheckPoint;

export { Timeline };
